import * as actions from "store/actions/bankBillet/create";
import IBankBillet from "Types/BankBillet";
import dayjs from "dayjs";

export interface BankBilletCreateState extends IBankBillet {
	loading: boolean;
	errors: any;
}

interface MyAction {
	type: string;
	payload: any;
}

const initialState: BankBilletCreateState = {
	loading: false,
	value: "",
	dueDate: dayjs().add(3, "day").format("DD/MM/YYYY"),
	description: "",
	document: "",
	name: "",
	email: "",
	street: "",
	number: "",
	complement: "",
	neighborhood: "",
	city: "Curitiba",
	state: "PR",
	country: "BR",
	zipCode: "",
	errors: {}
};

const reducer = function (state = initialState, action: MyAction) {
	const { type, payload } = action;
	switch (type) {
		case actions.CREATE_MEI: {
			return {
				...state,
				loading: true,
				errors: initialState.errors
			};
		}
		case actions.CREATE_MEI_SUCCESS: {
			return {
				...initialState
			};
		}
		case actions.CREATE_MEI_FAILED: {
			return {
				...state,
				loading: false,
				errors: payload
			};
		}
		case actions.SET_VALUE:
			return {
				...state,
				...payload
			};
		case actions.CLEAR_VALUES:
			return {
				...initialState
			};
		default: {
			return state;
		}
	}
};

export default reducer;
